import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import styles from './Divider2.js';

const Divider = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement("hr", _extends({
    ref: ref,
    className: classNames(className, styles.divider),
    role: "presentation"
  }, rest));
});

export { Divider as default };
